/**
 * @file: 直达订单图标 国旗图标
 * IconDirectPo
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/10/09      1.0     First version
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
const IconDirectPo = ({size=24,className=""}) => {
    return (<img className="iconfont" width={size} className={className}
             src={"https://oss.essaone.com/55f2b325-ba91-4df2-8d8b-52a9ab85c131.svg"}></img>
    );
}

export default IconDirectPo;
